import { render, staticRenderFns } from "./BKBadge.vue?vue&type=template&id=128a3a86&scoped=true"
import script from "./BKBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKBadge.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKBadge.vue?vue&type=style&index=0&id=128a3a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a3a86",
  null
  
)

export default component.exports